import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class SpotlightViewModel {
    BackToSignIn:        () => void;
    NewLoading:          (pMessage: string) => dmLoading;

    mlText:              MLText;
    app:                 mlBroker;
    ml:                  mlBroker;
    Hotel:               dmHotel;
    LangID:              number;

    HasEntry:            boolean;
    AllowSpotlightPrice: boolean;
    DiscountActive:      boolean;

    LastMinuteDiscount:  number;
    GeneralDiscount:     number;
    EarlyBirdDiscount:   number;

    Updated:             Date;
    UpdatedDisplay:      string;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: () => void
        ,pNewLoading:   (pMessage: string) => dmLoading
    ) {
        this.mlText              = pMLText;
        this.LangID              = this.mlText.GetLangID();
        this.app                 = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                  = this.mlText.GetBroker(
            'HotelAreaSpotlight'
        );

        this.Hotel               = pHotel;
        this.BackToSignIn        = pBackToSignIn;
        this.NewLoading          = pNewLoading;

        this.HasEntry            = false;
        this.AllowSpotlightPrice = false;
        this.DiscountActive      = false;

        this.refreshSettings();
    }

    private refreshSettings(): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let settingsParams = RQParam.OtaGetHotelSpotlightPriceStatusParams();

            settingsParams.HotelID = this.Hotel.HotelID;

            RQService.Ota.GetHotelSpotlightPriceStatus(settingsParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let settingsList = response.RQueryResult;

                let settings = RQService.Ota.PopulateGetHotelSpotlightPriceStatusRow(
                    settingsList[0]
                );

                this.HasEntry            = (settings.HasEntry            == 1);
                this.AllowSpotlightPrice = (settings.AllowSpotlightPrice == 1);

                let discountParams = RQParam.OtaGetHotelSpotlightDiscountsParams();

                discountParams.HotelID = this.Hotel.HotelID;

                RQService.Ota.GetHotelSpotlightDiscounts(discountParams).then((result) => {
                    let response = result as any;
                    
                    if (response.HasErrorOrException) { loading.Dismiss(); return; }
                    
                    let discountsList = response.RQueryResult;
                    
                    let discounts = RQService.Ota.PopulateGetHotelSpotlightDiscountsRow(
                        discountsList[0]
                    );

                    this.LastMinuteDiscount = discounts.LastMinuteDiscount;
                    this.GeneralDiscount    = discounts.GeneralDiscount;
                    this.EarlyBirdDiscount  = discounts.EarlyBirdDiscount;

                    this.DiscountActive     = (this.LastMinuteDiscount > 0);

                    this.Updated            = new Date(
                         parseInt(discounts.Updated.substr(0, 4))
                        ,(parseInt(discounts.Updated.substr(5, 2)) - 1)
                        ,parseInt(discounts.Updated.substr(8, 2))
                    );

                    this.UpdatedDisplay     = this.Updated.toLocaleDateString(
                         RQApp.LangCodesByID[this.LangID]
                        ,{
                             weekday: 'short'
                            ,year:    'numeric'
                            ,month:   'short'
                            ,day:     'numeric'
                        }
                    );

                    loading.Dismiss();
                });
            });
        });
    }

    public Save(pAllowSpotlightPrice: boolean): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaSetHotelSpotlightPriceStatusParams();

            saveParams.HotelID             = this.Hotel.HotelID;
            saveParams.AllowSpotlightPrice = (pAllowSpotlightPrice) ? 1 : 0;
            saveParams.LangID              = this.LangID;

            RQService.Ota.SetHotelSpotlightPriceStatus(saveParams).then((result) => {
                loading.Dismiss();

                this.refreshSettings();
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/spotlight/xv-spotlight.ts